// Add Comment Use Case
import { QueriesRepository } from "../repositories/QueriesRepository";
import { QueryCommentEntity, CreateCommentParams } from "../entities/QueryCommentEntity";
import { Result } from "../common/Result";

export class AddCommentUseCase {
  constructor(private repository: QueriesRepository) {}

  async execute(params: CreateCommentParams): Promise<Result<QueryCommentEntity>> {
    try {
      if (!params.queryId || params.queryId <= 0) {
        return Result.fail("Invalid query ID");
      }

      if (!params.comment || params.comment.trim().length === 0) {
        return Result.fail("Comment cannot be empty");
      }

      if (params.comment.length > 1000) {
        return Result.fail("Comment cannot exceed 1000 characters");
      }

      const comment = await this.repository.addComment(params);
      return Result.ok(comment);
    } catch (error: any) {
      return Result.fail(error.message || "Failed to add comment");
    }
  }
}

